import { Flue, FlueBurnMetricAggregate } from "firefly-my-chimney-ts-building";
import {
  FlueBurnMetricAggregateTimeUnit,
  flueBurnMetricAggregateTimeUnits,
} from "firefly-shared-ts-domain";
import { DateTime } from "luxon";
import { useTheme } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { resolveTimeUnitLabel } from "./resolveTimeUnitLabel";
import { SizeClass, useWindowWidth } from "shared-ts-ui-responsive";
import { ChartsYReferenceLineProps } from "@mui/x-charts-premium";
import { mergeYReferenceLines } from "./mergeYReferenceLines";

export const useResolveAvgMaxTemperatureReferenceLineProps = (
  flue: Flue,
  unit: string,
  month?: DateTime
): Array<ChartsYReferenceLineProps<number>> => {
  const theme = useTheme();
  const windowWidth = useWindowWidth();
  const { t } = useTranslation("firefly-shared-ts-domain");
  return useMemo(() => {
    const timeUnits: Array<FlueBurnMetricAggregateTimeUnit> = [
      flueBurnMetricAggregateTimeUnits.ever,
      flueBurnMetricAggregateTimeUnits.sinceSweep,
      flueBurnMetricAggregateTimeUnits.year,
      flueBurnMetricAggregateTimeUnits.month,
    ];
    const flueMetricsArray: Array<FlueBurnMetricAggregate> = [];
    timeUnits.forEach((timeUnit) => {
      const flueMetrics = flue.querySingleMetricsOrUndef(timeUnit, month);
      if (flueMetrics !== undefined) {
        flueMetricsArray.push(flueMetrics);
      }
    });

    const referenceLines: Array<ChartsYReferenceLineProps<number>> = [];
    const timeUnitLabelsLower: string[] = [];
    flueMetricsArray.forEach((flueMetrics) => {
      if (flueMetrics) {
        if (flueMetrics.values.temperatureAvgMax !== undefined) {
          const timeUnitLabel = resolveTimeUnitLabel(
            t,
            flueMetrics.timeUnit,
            flueMetrics.time
          );

          timeUnitLabelsLower.push(timeUnitLabel.toLowerCase());

          referenceLines.push({
            y: Math.round(flueMetrics.values.temperatureAvgMax),
            labelAlign: "end",
            lineStyle: {
              stroke: theme.palette.warning.main,
              strokeDasharray: theme.spacing(1),
              strokeDashoffset: theme.spacing(1),
            },
            label: `${t("Avg. Max Temp.")} (${timeUnitLabel.toLowerCase()}`,
            labelStyle: {
              fill: theme.palette.text.secondary,
              fontSize:
                windowWidth === SizeClass.Compact
                  ? "10px"
                  : windowWidth === SizeClass.Medium
                  ? "smaller"
                  : undefined,
            },
          });
        }
      }
    });

    return mergeYReferenceLines(referenceLines, timeUnitLabelsLower, unit, 5);
  }, [month, flue, windowWidth, theme, t, unit]);
};
